import React, { useContext, useState, useMemo } from "react";
import whyImg from "../../../Utils/Svg/why-bworkz-img.svg";
// import { BsFillPencilFill } from "react-icons/bs";
import Context from "../../../Context/Context";
import { useNavigate } from "react-router-dom";
import { API } from "aws-amplify";
// import Pagination from "@mui/material/Pagination";
import "../Stylesheets/upcoming.css";
import { toast } from "react-toastify";
// import "../../DashBordMobile/UpcomingSessions.css";

import PaginationComponent from "../../../common/Pagination";
import ClassTable from "./Components/ClassTable";
import ClassModal from "./Components/CreateEditClassModal";
import { useAlert } from "../../../common/CustomAlert";

const urlRegexPattern =
  /^https?:\/\/(?:[a-z0-9-]+\.)?(?:zoom|zoomgov)\.(?:us|gov)\/(?:j\/)?(?:[0-9]{9,15})(?:\?pwd=[a-zA-Z0-9_\-./]+)?$/;
const formatDate = (epochDate) => {
  const date = new Date(epochDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-indexed, so we add 1 to get the correct month
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

const UpcomingSessions = () => {
  const [selectedInstructor, setSelectedInstructor] = useState("");
  const [classType, setClassType] = useState("");
  const Ctx = useContext(Context);
  const UtilCtx = useContext(Context).util;
  const alert = useAlert();

  const filteredClasses = useMemo(() => {
    return (Ctx.upcomingClasses || [])
      .filter(
        (clas) =>
          (selectedInstructor === "" || clas.instructorNames === selectedInstructor) &&
          (classType === "" || clas.classType === classType)
      )
      .filter((clas) => {
        const classTime = new Date(parseInt(clas.date)).getTime();
        const currentTime = new Date().getTime();
        const oneHourInMillis = 60 * 60 * 1000;
        return classTime + oneHourInMillis > currentTime;
      })
      .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  }, [Ctx.upcomingClasses, selectedInstructor, classType]);

  // Remove duplicate classes
  function removeDuplicateClasses(filteredClasses) {
    const uniqueMap = new Map();
    filteredClasses.forEach((item) => {
      const key = `${item.date}|${item.instructorNames}|${item.classType}`;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, item);
      }
    });
    return Array.from(uniqueMap.values());
  }

  const classTypes = Array.from(
    new Set(filteredClasses.map((clas) => clas.classType))
  );
  const Navigate = useNavigate();
  const itemsPerPage = 4;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(Ctx.upcomingClasses.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const isDarkMode = Ctx.isDarkMode ?? true;
  const classTypeNameArray = [
    "Choreography by Anupam",
    "Instructor Training",
    "Cancellation",
  ];
  const uniqueClasses = removeDuplicateClasses(filteredClasses);
  const [modal, setModal] = useState(false);
  const [modalMode, setModalMode] = useState("edit");
  const [selectedClass, setSelectedClass] = useState(null);
  const userType = Ctx.userData.userType;

  const getInstructor = (name) => {
    return Ctx.instructorList.find(
      (i) => i.name?.toString().trim() === name?.toString().trim()
    );
  };
  const isAdmin =
    Ctx.userData.userType === "admin" || Ctx.userData.userType === "instructor";

  const onClassUpdated = async (
    classId,
    editedInstructorNames,
    editedClassType,
    instructorId,
    date
  ) => {
    UtilCtx.setLoader(true);

    try {
      if (!instructorId) {
        alert.warning("Please select an instructor.");
        UtilCtx.setLoader(false);
        return;
      }

      if (!editedClassType) {
        alert.warning("Please select a class type.");
        UtilCtx.setLoader(false);
        return;
      }

      const updatedClasses = Ctx.upcomingClasses.map((c) =>
        c.classId === classId
          ? {
              ...c,
              instructorNames: editedInstructorNames,
              instructorId: instructorId,
              classType: editedClassType,
              date,
            }
          : c
      );
      await API.put("user", "/admin/edit-schedule-name/Bworkz", {
        body: {
          classId: classId,
          instructorNames: editedInstructorNames,
          instructorId: instructorId,
          classType: editedClassType,
          date,
        },
      });

      Ctx.setUpcomingClasses(updatedClasses);

      alert.success("Class updated successfully!");
    } catch (e) {
      alert.error(e.message || "Failed to update class");
    } finally {
      UtilCtx.setLoader(false);
    }
  };

  const instructors = useMemo(
    () =>
      Array.from(
        new Set(Ctx.upcomingClasses.map((clas) => clas.instructorNames))
      ),
    [Ctx.upcomingClasses]
  );

  const handleClassAction = (classData, mode) => {
    setSelectedClass(classData);
    setModalMode(mode);
    setModal(true);
  };

  return (
    <>
      <div className={`w-full md:w-[calc(100%-5rem)] mx-auto mt-0 md:mt-10 flex flex-col h-full transition-colors duration-200 ${isDarkMode ? 'bg-black' : 'bg-white'}`} style={{ fontFamily: "Inter, sans-serif" }}>
          {/* Header Section */}
          <div className={`w-full px-3 md:px-8 py-3 md:py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-4 border-b ${isDarkMode ? 'border-[#2a2a2a]' : 'border-gray-200'}`}>
            <div className="flex items-center gap-2 sm:gap-4">
              <h1 className={`text-xl md:text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>Upcoming Classes</h1>
            </div>
            <div className="flex items-center gap-2 sm:gap-4 w-full sm:w-auto">
              {(Ctx.userData.userType === "admin" || Ctx.userData.userType === "instructor") && (
                <button
                  onClick={() => setModal(true)}
                  className="w-full sm:w-auto px-3 md:px-4 py-1.5 md:py-2 bg-[#FDCF08] text-black font-semibold rounded-lg flex items-center justify-center gap-1.5 md:gap-2 hover:bg-[#f0c000] transition-colors text-xs md:text-sm"
                  style={{ fontFamily: "Inter, sans-serif" }}
                >
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 3V13M3 8H13" stroke="black" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  <span>Add New Class</span>
                </button>
              )}
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1 overflow-y-auto px-3 md:px-8 py-3 md:py-6">
            {/* Classes Table */}
            <ClassTable
              classes={uniqueClasses.slice(startIndex, endIndex)}
              userType={Ctx.userData.userType}
              instructorList={Ctx.instructorList}
              getInstructor={getInstructor}
              onAction={handleClassAction}
              classTypeNameArray={classTypeNameArray}
              isDarkMode={isDarkMode}
            />

            <div className="mt-4 md:mt-6">
              <PaginationComponent
                showIcons={true}
                data={uniqueClasses}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </div>

          <ClassModal
            isOpen={modal}
            onClose={() => {
              setModal(false);
              setSelectedClass(null);
            }}
            classTypeNameArray={classTypeNameArray}
            instructorList={Ctx.instructorList}
            userData={Ctx.userData}
            setUpcomingClasses={Ctx.setUpcomingClasses}
            upcomingClasses={Ctx.upcomingClasses}
            util={UtilCtx}
            classData={selectedClass}
            setModalMode={setModalMode}
            readOnly={modalMode === "view"}
          />
      </div>
    </>
  );
};

export default UpcomingSessions;
